import { zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

export const MaintenanceBarWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  top: 0;
  left: 0;
  z-index: ${zIndex.Alert};
`
